export function normalizeProgress(
  progress?: number | null,
  processed?: number | null,
  total?: number | null,
): number | null {
  if (typeof progress === 'number' && Number.isFinite(progress)) {
    const scaled = progress > 1 ? progress / 100 : progress;
    if (scaled >= 0) {
      return Math.min(1, scaled);
    }
  }

  if (
    typeof processed === 'number'
    && Number.isFinite(processed)
    && typeof total === 'number'
    && Number.isFinite(total)
    && total > 0
  ) {
    return Math.min(1, Math.max(0, processed / total));
  }

  return null;
}
